import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_19363_64614)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.3334 7.05742L8.94275 0.666749C8.69271 0.416788 8.35364 0.276367 8.00008 0.276367C7.64653 0.276367 7.30745 0.416788 7.05742 0.666749L0.666749 7.05808C0.416788 7.30812 0.276367 7.6472 0.276367 8.00075C0.276367 8.3543 0.416788 8.69338 0.666749 8.94342V8.94342L7.05742 15.3334C7.30745 15.5834 7.64653 15.7238 8.00008 15.7238C8.35364 15.7238 8.69271 15.5834 8.94275 15.3334L15.3334 8.94342C15.4573 8.8196 15.5555 8.67259 15.6226 8.51079C15.6896 8.34898 15.7241 8.17556 15.7241 8.00042C15.7241 7.82527 15.6896 7.65185 15.6226 7.49005C15.5555 7.32824 15.4573 7.18123 15.3334 7.05742V7.05742ZM7.37875 4.27808C7.37875 4.10127 7.44899 3.9317 7.57401 3.80668C7.69904 3.68165 7.86861 3.61142 8.04542 3.61142C8.22223 3.61142 8.3918 3.68165 8.51682 3.80668C8.64184 3.9317 8.71208 4.10127 8.71208 4.27808L8.71208 8.27808C8.71208 8.45489 8.64184 8.62446 8.51682 8.74949C8.3918 8.87451 8.22223 8.94475 8.04542 8.94475C7.86861 8.94475 7.69904 8.87451 7.57401 8.74949C7.44899 8.62446 7.37875 8.45489 7.37875 8.27808L7.37875 4.27808ZM8.07942 11.9514L8.06075 11.9514C7.79789 11.9504 7.54559 11.8479 7.35651 11.6653C7.16744 11.4827 7.05622 11.2341 7.04608 10.9714C7.04119 10.8407 7.06241 10.7104 7.1085 10.588C7.15459 10.4656 7.22464 10.3537 7.31453 10.2587C7.40442 10.1637 7.51236 10.0876 7.63202 10.0348C7.75168 9.98208 7.88066 9.95372 8.01142 9.95142L8.03008 9.95142C8.29304 9.95209 8.54553 10.0545 8.73468 10.2372C8.92382 10.4199 9.03494 10.6686 9.04475 10.9314C9.04965 11.0621 9.02843 11.1924 8.98233 11.3148C8.93624 11.4372 8.86619 11.5492 8.7763 11.6442C8.68641 11.7391 8.57848 11.8152 8.45881 11.868C8.33915 11.9208 8.21017 11.9491 8.07942 11.9514Z",
			fill: "#F2B014"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_19363_64614",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgWarning);
export default ForwardRef;
